/* eslint-disable no-undef */
import { version } from '../../package.json'

export function generateStoreName(clientName = import.meta.env.VUE_APP_CLIENT_NAME, ver = version) {
  const suffix = import.meta.env.DEV ? __APP_VERSION__ : ver.replaceAll('.', '_')
  return clientName + '_' + suffix
}
